import * as React from 'react';
import * as ReactDOM from 'react-dom';

export interface IRestProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

type IListeners = { [key: string]: (ev: CustomEvent) => void };

type ReceivedComponent<P> = React.ComponentClass<P>;

export const withEvents = <P extends IRestProps>(Component: ReceivedComponent<P>) =>
    class WithEvents extends React.Component<P & IRestProps> {
        static displayName = 'WithEvents';
        listeners: IListeners = {};
        mountPoint: React.Component<P> | null;

        public componentDidMount() {
            const { name: _, config, children, ...restOfProps } = this.props;
            const allProps = { ...config, ...restOfProps };
            const funcs = Object.keys(allProps).filter(
                propName => typeof allProps[propName] === 'function'
            );

            const node = ReactDOM.findDOMNode(this.mountPoint);

            if (node) {
                funcs.forEach(functionName => {
                    this.listeners[functionName] = (event: CustomEvent) => {
                        const params = Array.isArray(event.detail) ? event.detail : [];
                        allProps[functionName](...params);
                    };
                    node.addEventListener(functionName, this.listeners[functionName], false);
                });
            }
        }

        public componentWillUnmount() {
            const node = ReactDOM.findDOMNode(this.mountPoint);

            Object.keys(this.listeners).forEach(functionName => {
                if (node) {
                    node.removeEventListener(functionName, this.listeners[functionName]);
                }
            });
        }

        public render() {
            return <Component {...this.props} ref={ref => (this.mountPoint = ref)} />;
        }
    };
